module.exports = __webpack_public_path__ + "static/img/loginBanner.0534930.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/loginBanner.webp
// module id = Vwzz
// module chunks = 0